import { createIcon } from './createIcon'

export const BellIcon = createIcon({
  displayName: 'BellIcon',
  viewBox: '0 0 16 20',
  path: [
    <path
      fill="currentColor"
      d="M8 20C6.89605 19.9946 6.00092 19.1039 5.99 18H9.99C9.99211 18.2674 9.94113 18.5325 9.84 18.78C9.57766 19.382 9.04181 19.8211 8.4 19.96H8.395H8.38H8.362H8.353C8.23682 19.9842 8.11865 19.9976 8 20ZM16 17H0V15L2 14V8.5C1.94732 7.08912 2.26594 5.68913 2.924 4.44C3.57904 3.28151 4.6987 2.45888 6 2.18V0H10V2.18C12.579 2.794 14 5.038 14 8.5V14L16 15V17Z"
    />,
  ],
})
